<div class="flex flex-col w-full h-full">

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ $safeNavigationMigration(dtypeForm?.dType?.caption) | localize }}</div>
        <button mat-icon-button matDialogClose>
            <mat-icon class="text-current" svgIcon="feather:x"></mat-icon>
        </button>
    </div>

    <!-- Loader -->
    @if (isLoading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <!-- Content -->
    @if (!showConditions) {
        <div class="flex flex-col flex-auto p-6 sm:p-8" fuseScrollbar>
            @if (dtypeForm) {
                <div class="flex flex-row flex-auto items-baseline flex-wrap w-full">
                    @for (column of dtypeForm.dType?.column; track column.name) {
                        @if (dtypeForm.fields[column.name]; as field) {
                            @if (!field.hidden) {
                                @if (field.browserOpts?.newLine) {
                                    <div class="w-full"></div>
                                }
                                @if (readonly || !isUpdate || !fieldsWithCondition.includes(column.name)) {
                                    <ng-container *ngTemplateOutlet="fieldWithoutCondition; context: { field, isUpdate }"></ng-container>
                                } @else {
                                    <ng-container *ngTemplateOutlet="fieldWithCondition; context: { field, isUpdate }"></ng-container>
                                }
                            }
                        }
                    }
                    @if (acceptFilters()) {
                        <ng-container *ngTemplateOutlet="filters"></ng-container>
                    }
                </div>
            }
        </div>

        <!-- Footer -->
        @if (!readonly) {
            <div  class="flex flex-0 items-center justify-end px-6 py-4 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10">
                <button mat-stroked-button matDialogClose>{{ 'cancel' | transloco }}</button>
                <button mat-flat-button color="primary" (click)="save()">{{ 'save' | transloco }}</button>
            </div>
        }
    } @else {
        <div class="flex flex-col flex-auto p-6 sm:p-8" fuseScrollbar>
            <div class="flex gap-4 p-4 text-lg">
                <span><b>{{ 'command.field' | transloco }}</b>: {{ dtypeForm.control.get('name').value }}</span>
                <span><b>{{ 'command.consequence' | transloco }}</b>: {{ 'command.' + currentConditionField + 'Command' | transloco }}</span>
            </div>

            <p class="text-xl font-semibold tracking-tight p-4">{{ 'command.conditions' | transloco }}</p>

            <div class="flex flex-col" fuseScrollReset>

                <!-- Table actions -->
                <div class="flex flex-row items-center justify-end py-2 px-4 gap-2">
                    <button mat-flat-button color="primary" (click)="addCondition()">{{ 'command.addCondition' | transloco }}</button>
                </div>

                <!-- Table -->
                <div class="flex flex-col mb-6 overflow-y-auto">

                    <!-- Header -->
                    <div class="flex flex-row gap-4 sticky top-0 px-6 py-4 text-md font-semibold text-secondary
                                shadow bg-gray-50 dark:bg-black dark:bg-opacity-5 md:px-8">
                        <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                        </mat-checkbox>
                        <div class="flex-auto w-48">
                            {{ 'command.field' | transloco }}
                        </div>
                        <div class="flex-auto w-64">
                            {{ 'command.condition' | transloco }}
                        </div>
                        <div class="flex-auto w-48">
                            {{ 'command.value(s)' | transloco }}
                        </div>
                        <div class="flex-auto w-12"></div>
                    </div>

                    @if (dtype?.path?.length > 0) {
                        @for (conditionPath of availableConditions; track conditionPath; let i = $index) {
                            <div class="flex flex-row gap-4 items-center px-6 py-3 cursor-pointer hover:bg-sky-100 dark:hover:bg-hover
                                    border-b md:px-8" [class.bg-sky-50]="selection.isSelected(conditionPath.path)" [ngClass]="{ 'bg-sky-50 dark:bg-hover': selection.isSelected(conditionPath.path) }"
                                    (click)="editCondition(conditionPath)">
                                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(conditionPath.path) : null"
                                    [checked]="selection.isSelected(conditionPath.path)">
                                </mat-checkbox>
                                <div class="flex-auto w-48">
                                    {{ conditionPath.field }}
                                </div>
                                <div class="flex-auto w-64">
                                    {{ conditionPath.operator | transloco }}
                                </div>
                                <div class="flex-auto w-48">
                                    {{ conditionFieldIsSelectOrAutocomplete(conditionPath.fieldType) ? getConditionSelectFieldCaption(conditionPath) : displayOperand(conditionPath.operand) }}
                                </div>
                                <div class="flex-auto w-12">
                                    <button mat-icon-button color="warn" (click)="removeCondition($event, i)">
                                        <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                    </button>
                                </div>
                            </div>
                        }
                    } @else {
                        <div class="flex justify-center font-semibold px-6 py-8 md:px-8">
                            {{ 'command.noConditions' | transloco }}
                        </div>
                    }

                </div>
            </div>
            <mat-hint>{{ 'command.hint' | transloco }}</mat-hint>
            <div class="flex flex-col gap-2 p-4">
                <mat-slide-toggle [checked]="!currentCommand.matchAll" (change)="toggleMatchAll($event, 'no')" color="primary">{{ 'command.noMatchAll' | transloco }}</mat-slide-toggle>
                <mat-slide-toggle [checked]="currentCommand.matchAll" (change)="toggleMatchAll($event, 'yes')" color="primary">{{ 'command.matchAll' | transloco }}</mat-slide-toggle>
                <mat-slide-toggle [(ngModel)]="currentCommand.clear" color="primary">{{ 'command.clear' | transloco }}</mat-slide-toggle>
            </div>
        </div>

        <div class="flex flex-0 items-center justify-end px-6 py-4 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10">
            <button mat-stroked-button (click)="closeConditions()">{{ 'cancel' | transloco }}</button>
            <!-- <button mat-flat-button color="accent" (click)="deleteConditions()">{{ 'command.deleteConditionsAndClose' | transloco }}</button> -->
            <button mat-flat-button color="primary" (click)="saveConditions()">{{ 'save' | transloco }}</button>
        </div>
    }
</div>


<ng-template #fieldWithoutCondition let-field="field" let-isUpdate="isUpdate">
    <dtype-item [ngClass]="{
        'w-full': field.browserOpts?.width === 'FULL',
        'w-1/2': field.browserOpts?.width === 'HALF',
        'w-1/3': field.browserOpts?.width === 'THIRD',
        'w-2/3': field.browserOpts?.width === 'TWO_THIRDS',
        'w-1/4': field.browserOpts?.width === 'FOURTH',
        'w-3/4': field.browserOpts?.width === 'THREE_FOURTHS',
        'w-1/5': field.browserOpts?.width === 'FIFTH',
        'w-2/5': field.browserOpts?.width === 'TWO_FIFTH',
        'w-3/5': field.browserOpts?.width === 'THREE_FIFTHS',
        'w-4/5': field.browserOpts?.width === 'FOUR_FIFTHS',
        'w-1/6': field.browserOpts?.width === 'SIXTH',
        'w-5/6': field.browserOpts?.width === 'FIVE_SIXTHS',
        'px-2 py-2': !field.hidden && field.type !== embeddedItemUri && field.type !== embeddedItemCollectionUri
    }" [field]="field" [isUpdate]="isUpdate"></dtype-item>
</ng-template>


<ng-template #fieldWithCondition let-field="field" let-isUpdate="isUpdate">
    <div [ngClass]="{
        'w-full': field.browserOpts?.width === 'FULL',
        'w-1/2': field.browserOpts?.width === 'HALF',
        'w-1/3': field.browserOpts?.width === 'THIRD',
        'w-2/3': field.browserOpts?.width === 'TWO_THIRDS',
        'w-1/4': field.browserOpts?.width === 'FOURTH',
        'w-3/4': field.browserOpts?.width === 'THREE_FOURTHS',
        'w-1/5': field.browserOpts?.width === 'FIFTH',
        'w-2/5': field.browserOpts?.width === 'TWO_FIFTH',
        'w-3/5': field.browserOpts?.width === 'THREE_FIFTHS',
        'w-4/5': field.browserOpts?.width === 'FOUR_FIFTHS',
        'w-1/6': field.browserOpts?.width === 'SIXTH',
        'w-5/6': field.browserOpts?.width === 'FIVE_SIXTHS',
        'px-2 py-2': !field.hidden && field.type !== embeddedItemUri && field.type !== embeddedItemCollectionUri
    }" class="flex items-center gap-2">
        <dtype-item [field]="field" [isUpdate]="isUpdate"></dtype-item>
        <button mat-icon-button class="rounded" [color]="fieldHasPath(field) ? 'primary' : 'accent'"
            [ngClass]="{ 'border-solid border-2 border-primary': fieldHasPath(field) }" (click)="openConditions(field.name)">
            <mat-icon class="text-primary" [svgIcon]="'mat_outline:call_split'"></mat-icon>
        </button>
    </div>
</ng-template>

<ng-template #filters>
    @if (dtypeForm.control.get('uri')?.value) {
        <div class="flex flex-1 justify-between items-center">
            <div class="leading-6 font-medium">{{ 'filters.title' | transloco }}</div>
            @if (!readonly) {
                <button mat-flat-button class="mr-4" color="primary" (click)="addFilter()">
                    <mat-icon class="icon-size-5 mr-2" svgIcon="mat_outline:add"></mat-icon>
                    {{ 'add' | transloco }}
                </button>
            }
        </div>

        @for (filter of dtypeColumn.filter; track filter; let i = $index) {
            <div class="flex w-full items-center p-2" animate.enter="fade-in" animate.leave="fade-out">
                <mat-form-field class="w-1/6 mx-2">
                    <mat-label>{{ 'filters.type' | transloco }}</mat-label>
                    <mat-select [(ngModel)]="filter.type" (selectionChange)="filterTypeChanged($event, filter)" [disabled]="readonly">
                        <mat-option value="otherfield">
                            {{ 'filters.otherfield' | transloco }}
                        </mat-option>
                        <mat-option value="value">
                            {{ 'filters.value' | transloco }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                @if (filter.type === 'otherfield') {
                    <mat-form-field class="w-1/4 mx-2">
                        <mat-label>{{ 'filters.formfield' | transloco }}</mat-label>
                        <mat-select [(ngModel)]="filter.outerField" [disabled]="readonly">
                            @if (!data.table) {
                                @for (field of dtypeFields; track field.name) {
                                    <mat-option [value]="field.name">
                                        {{ field.caption | localize }}
                                    </mat-option>
                                }
                            } @else {
                                @for (field of dtypeFields; track field.name) {
                                    <mat-option [value]="data.table.name + '.' + field.name">
                                        <mat-icon class="mr-2" [svgIcon]="'mat_outline:table_view'"></mat-icon>
                                        {{ field.caption | localize }}
                                    </mat-option>
                                }
                                @for (field of parentDtypeFields; track field.name) {
                                    <mat-option [value]="field.name">
                                        {{ field.caption | localize }}
                                    </mat-option>
                                }
                            }
                        </mat-select>
                    </mat-form-field>
                } @else if (filter.type === 'value') {
                    <mat-form-field class="w-1/4 mx-2">
                        <mat-label>{{ 'filters.value' | transloco }}</mat-label>
                        <input matInput [(ngModel)]="filter.value" type="text" [disabled]="readonly">
                    </mat-form-field>
                }
                <mat-form-field class="w-1/8 mx-2">
                    <mat-label>{{ 'filters.condition' | transloco }}</mat-label>
                    <mat-select [(ngModel)]="filter.condition" [disabled]="readonly">
                        <mat-option [value]="'EQUALS'">
                            {{ 'filters.equals' | transloco }}
                        </mat-option>
                        <mat-option [value]="'NOT_EQUALS'">
                            {{ 'filters.notEquals' | transloco }}
                        </mat-option>
                        <mat-option [value]="'INCLUDED'">
                            {{ 'filters.included' | transloco }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="w-1/4 mx-2">
                    <mat-label>{{ 'filters.masterField' | transloco }}</mat-label>
                    <mat-select [(ngModel)]="filter.innerField" [disabled]="readonly">
                        @for (field of masterFields; track field.name) {
                            <mat-option [value]="field.name">
                                {{ field.caption | localize }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                @if (!readonly) {
                    <button mat-icon-button class="ml-2" (click)="removeFilter(i)" [matTooltip]="'filters.delete' | transloco">
                        <mat-icon class="icon-size-6" svgIcon="heroicons_outline:trash"></mat-icon>
                    </button>
                }
            </div>
        } @empty {
            <div class="flex justify-center w-full font-semibold px-6 py-8 md:px-8" animate.enter="fade-in" animate.leave="fade-out">
                {{ 'filters.noFilters' | transloco }}
            </div>
        }
        @if (!readonly) {
            <div class="mb-2 ml-4 leading-6 font-medium text-hint">{{ 'filters.invalidFiltersWarning' | transloco }}</div>
        }
    }
</ng-template>
